import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import { SelectProps } from '@mui/material/Select'
import * as Styles from './styles'

interface ISelect {
  id: string
  label: string
  options: Array<{ id: number | string; label: string }>
  initialValues?: Array<{ id: number | string; label: string }>
}

export type TSelectProps = SelectProps & ISelect

const SingleSelect: React.FC<TSelectProps> = ({
  id = 'default-select',
  label = 'default multiple select',
  options = [],
  initialValues = [],
  ...restProps
}) => {
  return (
    <div>
      <Styles.FormControl>
        <InputLabel id={`component-single-checkbox-label-${id}`}>
          {label}
        </InputLabel>
        <Styles.Select
          labelId={`component-single-checkbox-label-${id}`}
          id={`component-single-checkbox-${id}`}
          name={`${id}`}
          label={label}
          {...restProps}
        >
          {options.map(({ id: optionId, label: optionLabel }) => (
            <MenuItem key={optionId} value={optionId}>
              {optionLabel}
            </MenuItem>
          ))}
        </Styles.Select>
      </Styles.FormControl>
    </div>
  )
}

export default SingleSelect
